// Frontend permission gating — mirrors the backend operator permissions.
export type Perm = 'intake' | 'metadata' | 'matching' | 'processing' | 'dossier' | 'users' | 'studios';

export const WORKFLOW_PERMS: Perm[] = ['intake', 'metadata', 'matching', 'processing', 'dossier'];

// A nav item / route requires: a specific permission, "anyWorkflow" (any of the
// pipeline permissions), or null (any authenticated operator).
export type PermReq = Perm | 'anyWorkflow' | null;

export function allowed(perms: string[] | undefined, req: PermReq): boolean {
  if (req == null) return true;
  const p = perms ?? [];
  if (req === 'anyWorkflow') return WORKFLOW_PERMS.some((w) => p.includes(w));
  return p.includes(req);
}
